module.exports = __webpack_public_path__ + "static/36575D_0_0-d44de1ccbeb5c8413bf8535cb5408b10.ttf";